export default __webpack_public_path__ + "static/media/gb-eng.0da2d3ca.svg";